<!--
    補足マニュアルを表示するコンポーネント

    使用方法
        <InformationManual :arMessage="['<div>ログの保存期間は731日です。</div>']"></InformationManual>

    注意点
        原因はわかっていませんが、styleを指定できません。
        classは指定できます。
        デバッグは<i>タグに「data-bs-trigger="click"」を付けるとやりやすいです。
-->
<template>
    <template v-if="!disabled">
        <div class="icon-font-blue-s">
            <i class="icon-infoCircle"
               height="20"
               :data-bs-toggle="strToggle"
               data-bs-placement="bottom"
               data-bs-html="true"
               :data-bs-original-title="strHTML"></i>
        </div>
    </template>
    <template v-else>
        <div class="disabled-scv-opacity icon-font-blue-s">
            <i class="icon-infoCircle"
               height="20"></i>
        </div>
    </template>
</template>

<script lang="ts">
    import { Vue, Options } from "vue-class-component";
    import { Tooltip } from "bootstrap";

    @Options({
        props: {
            arMessage: { type: Array, required: true },                                         // [in]（必須）表示情報（HTML）
            disabled: { type: Boolean, default: false },                                        // [in]（オプション） 有効/無効
            dispMode: { type: Number, default: 0 },                                             // 0:デフォルト 1:横幅の最大サイズ720px
            dispPlacePriority: { type: Array, default: ['top', 'bottom', 'right', 'left'] },    // [in]（オプション）tooltipを表示させる場所と優先度
        },
        watch: {
            // 動的に補足マニュアルの内容を切り替える
            arMessage: {
                handler: function () {
                    this.createHTML();
                },
                deep: true,     // オブジェクトの監視
                immediate: false
            }
        },
    })

    export default class InformationManual extends Vue {
        private strHTML = "";
        private arMessage!: Array<string>;
        private readonly dispMode!: number;
        private dispPlacePriority!: Array<string>;
        private strToggle = "";

        public mounted(): void {
            // 横幅の最大サイズ720px
            if (0 != (1 & this.dispMode)) {
                this.strToggle = "tooltip tooltip-font scv-tooltip-manual-large";
            }
            else {
                this.strToggle = "tooltip tooltip-font scv-tooltip-manual";
            }

            this.createHTML();
        }

        /**
         * 補足マニュアルの内容を作成
         */
        private createHTML(): void {

            this.strHTML = "";

            // アイコン
            let strIconHtml = '<div class="icon-font-blue">';
            strIconHtml += '<i class="icon-infoCircle" height="24" /></i>';
            strIconHtml += '</div>'

            // タイトル
            this.strHTML = '<div class="tooltip-manual-header-scv d-flex flex-row">'
            this.strHTML += strIconHtml;
            this.strHTML += '<div class="tooltip-manual-header-text-scv">補足マニュアル（補足説明）</div>';
            this.strHTML += '</div>'

            // メッセージ
            this.strHTML += '<div class="tooltip-manual-body-scv">'
            this.arMessage.forEach(x => {
                this.strHTML += x;
            });
            this.strHTML += '</div>'
        }

        public updated(): void {
            // tooltip()はDOM描画前に呼ばれているようなので、DOM描画後にtooltip()を呼ばないと、バインドされない
            document.querySelectorAll('[data-bs-toggle="' + this.strToggle + '"]').forEach(x => {
                new Tooltip(x, {
                    template:
                        '<div class="' + this.strToggle + '" role="tooltip">' +
                        '<div class="tooltip-arrow"></div>' +
                        '<div class="tooltip-inner"></div>' +
                        '</div>',
                    fallbackPlacements: this.dispPlacePriority, // 自動調整される位置を指定
                    sanitize: false,    // tableタグやスタイルの指定を許可する
                    html: true,
                })
            });
        }
    }
</script>